import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

const Container = styled.div`
  margin: 0 auto;
  max-width: 1000px;
  display: none;
  justify-content: flex-end;
  height: 30px;

  ${breakpoint('desktop')`
    display: flex;
  `}

  ul {
    box-sizing: border-box;
    color: rgb(34, 34, 34);
    display: block;
    border: 0px none rgb(34, 34, 34);
    font: normal normal 400 normal 14px / 21px 'Helvetica Neue', Helvetica,
      Roboto, Arial, sans-serif;
    margin: 0;
    outline: rgb(34, 34, 34) none 0px;
    padding: 0;

    &.CountrySelectorMenu {
      position: absolute;
      top: 100%;
      left: -1px;
      right: -1px;
      display: block;
      background-color: #fff;
      border: 1px solid #e6e6e6;
      padding: 10px 0;
      z-index: 999;
      transition: opacity 0.5s;

      &.collapsed {
        opacity: 0;
        pointer-events: none;
      }

      &.expanded {
        opacity: 1;
      }

      li {
        display: block;
        width: 100%;
      }

      a {
        display: block;
        width: 100%;
        background: #fff;
        text-align: left;
        height: auto;
        padding: 7px 21px 7px 18px;

        &:hover {
          background-color: #f1f2f2;
        }
      }
    }
  }

  li {
    box-sizing: border-box;
    color: rgb(34, 34, 34);
    text-decoration: none;
    text-size-adjust: 100%;
    border: 0px none rgb(34, 34, 34);
    font: normal normal 400 normal 14px / 21px 'Helvetica Neue', Helvetica,
      Roboto, Arial, sans-serif;
    list-style: none outside none;
    outline: rgb(34, 34, 34) none 0px;
    display: inline-block;
  }

  a {
    box-sizing: border-box;
    color: rgb(0, 0, 0);
    display: block;
    height: 39px;
    text-align: center;
    text-decoration: none;
    background: rgb(241, 242, 242) none repeat scroll 0% 0% / auto padding-box
      border-box;
    font: normal normal 400 normal 13px / 13px Graphik-Regular, 'Lucida Grande',
      'Lucida Sans', Tahoma, sans-serif;
    list-style: none outside none;
    padding: 13px 20px;
    font-size: 13px;
    line-height: 13px;
    white-space: nowrap;
    text-transform: capitalize;

    &.first {
      color: rgb(220, 20, 49);
      text-size-adjust: 100%;
      white-space: nowrap;
      width: 100px;
      border: 0px none rgb(220, 20, 49);
      background: #fff;
    }

    &.bel {
      color: rgb(255, 255, 255);
      background: rgb(74, 74, 74) none repeat scroll 0% 0% / auto padding-box
        border-box;
    }
  }

  button {
    cursor: pointer;
    position: relative;
    text-size-adjust: 100%;
    border: none;
    outline: 1px solid rgb(230, 230, 230);
    font: normal normal 400 normal 13px / 13px Graphik-Regular, 'Lucida Grande',
      'Lucida Sans', Tahoma, sans-serif;
    margin: 0;
    padding: 13px 55px 13px 20px;
    box-sizing: border-box;
    background: #fff;

    &:after {
      content: ' ';
      width: 6px;
      height: 6px;
      border: solid 1px #333;
      border-left: none;
      border-top: none;
      display: inline-block;
      transform: rotate(45deg);
      position: absolute;
      top: 16px;
      right: 20px;
      transition: transform 0.5s ease;
    }

    &.expanded:after {
      transform: rotate(-135deg);
    }
  }
`

const Paises = [
  { title: 'Costa Rica', url: 'https://www.baccredomatic.com/es-cr' },
  { title: 'El Salvador', url: 'https://www.baccredomatic.com/es-sv' },
  { title: 'Nicaragua', url: 'https://www.baccredomatic.com/es-ni' },
  { title: 'Honduras', url: 'https://www.baccredomatic.com/es-hn' },
  { title: 'Guatemala', url: 'https://www.baccredomatic.com/es-gt' },
  { title: 'Panamá', url: 'https://www.baccredomatic.com/es-pa' },
  { title: 'Bahamas', url: 'https://www.baccredomatic.com/es-bs' },
  { title: 'Grand Cayman', url: 'https://www.baccredomatic.com/es-ky' },
]

class TopMenu extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      expanded: false,
    }
    this.toggleCountries = this.toggleCountries.bind(this)
  }

  toggleCountries() {
    this.setState({ expanded: !this.state.expanded })
  }

  render() {
    const { countrySlug, countryName } = this.props
    const expandedClass = this.state.expanded ? 'expanded' : 'collapsed'

    return (
      <Container>
        <ul>
          <li>
            <a
              href={`https://www.baccredomatic.com/${countrySlug}/banca-personas`}
              className="first"
            >
              Personas
            </a>
          </li>
          <li>
            <a href={`https://www.baccredomatic.com/${countrySlug}/pymes`}>
              PYMES
            </a>
          </li>
          <li>
            <a
              href={`https://www.baccredomatic.com/${countrySlug}/comercios-afiliados`}
            >
              Afiliados
            </a>
          </li>
          <li>
            <a
              href={`https://www.baccredomatic.com/${countrySlug}/corporaciones-e-instituciones`}
            >
              Corporaciones
            </a>
          </li>
          <li>
            <a
              href={`https://www.baccredomatic.com/${countrySlug}/nuestra-empresa`}
              className="last"
            >
              Nuestra Empresa
            </a>
          </li>
          <li>
            <a
              href="https://www.sucursalelectronica.com/redir/showLogin.go"
              className="bel"
            >
              Banca en línea
            </a>
          </li>
          <li style={{ position: 'relative' }}>
            <button className={expandedClass} onClick={this.toggleCountries}>
              {countryName}
            </button>
            <ul className={`CountrySelectorMenu ${expandedClass}`}>
              {Paises.map((p, i) => (
                <li key={i}>
                  <a href={p.url}>{p.title}</a>
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </Container>
    )
  }
}

export default TopMenu
